import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "readwise",
  "use": "readwise-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"readwise\"><path d=\"M9.307 1c5.008 0 7.625 1.054 7.625 4.757 0 2.802-1.362 4.14-4.108 4.6l3.685 5.994c.65 1.08 1.18 1.44 2.264 1.568V19h-5.347l-5.008-8.358H7.167v5.478c0 1.467.362 1.67 1.904 1.8V19H1v-1.08c1.542-.13 1.904-.336 1.904-1.8V3.88c0-1.491-.314-1.67-1.904-1.8V1h8.307Zm3.218 1.928-5.424 5.99c1.246-1.035 4.864-1.114 5.298-1.12h.043a.397.397 0 0 0 .314-.407s-.656-3.682-.23-4.463Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol